import { useEffect, useState } from "react";
import { set } from "lodash/object";

const useForm = (props) => {
    const [values, setValues] = useState({});
    const [caret, setPosition] = useState(0);
    const [target, setTarget] = useState(null);

    useEffect(() => {
        if (caret != null && target != null) {
            try {
                target.setSelectionRange(caret, caret);
            } catch {
                /* Ignore catch */
                /* This catch exists mostly because Safari/Apple and their date
                 * pickers seem to cause a type error. This might also be a fix
                 * for the file input on Apple devices. */
            }
        }
    }, [target?.value]);

    const forceValue = (key, value, options = {}) => {
        let payload = { ...values }
        set(payload, key, value);

        setValues(payload);
        if (props?.key?.length > 0 && props?.context != null) {
            props?.context?.dispatch({ type: options?.action ?? props?.context?.defaultAction, payload: payload });
        }
    };

    const resetValue = key => {
        let payload = { ...values };
        set(payload, key, null);

        setValues(payload);
        if (props?.key?.length > 0 && props?.context != null) {
            props?.context?.dispatch({ type: props?.context?.defaultAction, payload: payload });
        }
    };

    const handleChange = (e, pattern = null) => {
        try {
            setPosition(e.target.selectionStart);
        } catch {
            /* Ignore catch */
            /* This catch exists mostly because Safari/Apple and their date
             * pickers seem to cause a type error. This might also be a fix
             * for the file input on Apple devices. */
        }
        setTarget(e.target);

        let payload = { ...values };
        set(payload, e.target.name, e.target.value);

        setValues(payload);
        if (props?.key?.length > 0 && props?.context != null) {
            props?.context?.dispatch({ type: props?.context?.defaultAction, payload: payload });
        }
    };

    return {
        values, forceValue, resetValue, handleChange,
    };
};

export default useForm;
